/* tslint:disable */
/* eslint-disable */
/**
 * Ак Барс Недвижимость API
 * Инструменты разработчика:  [ [Документация API. Swagger](/docs/) ]  [ [Документация API. Redoc](/redoc/) ] [ [Панель администрирования](/admin/) ] [ [Документация Image-Service](/api/attachments/docs/) ]
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 *
 * @export
 * @interface CatalogItem
 */
export interface CatalogItem {
  /**
   *
   * @type {number}
   * @memberof CatalogItem
   */
  readonly id?: number;
  /**
   *
   * @type {string}
   * @memberof CatalogItem
   */
  buildingState: string;
  /**
   *
   * @type {Array<{uuid: string, name: string, date: string, ext: string, leadId: number}>}
   * @memberof CatalogItem
   */
  docs: Array<{
    uuid: string;
    name: string;
    date: string;
    ext: string;
    leadId: number;
  }>;
  /**
   *
   * @type {boolean}
   * @memberof CatalogItem
   */
  isHandOver: boolean;
  /**
   *
   * @type {string}
   * @memberof CatalogItem
   */
  complexTitle: string;
  /**
   *
   * @type {string}
   * @memberof CatalogItem
   */
  readonly houseNumber?: string;
  /**
   *
   * @type {string}
   * @memberof CatalogItem
   */
  readonly dateSaleEnd?: string;
  /**
   *
   * @type {string}
   * @memberof CatalogItem
   */
  dateComplete: string;
  /**
   *
   * @type {Array<string>}
   * @memberof CatalogItem
   */
  planImages?: Array<string> | null;
  /**
   *
   * @type {string}
   * @memberof CatalogItem
   */
  address: string;
  /**
   *
   * @type {number}
   * @memberof CatalogItem
   */
  maxFloor: number;
  /**
   *
   * @type {string}
   * @memberof CatalogItem
   */
  status: string;
  /**
   *
   * @type {Date}
   * @memberof CatalogItem
   */
  readonly createdAt?: Date;
  /**
   *
   * @type {Date}
   * @memberof CatalogItem
   */
  readonly updatedAt?: Date;
  /**
   *
   * @type {string}
   * @memberof CatalogItem
   */
  type?: CatalogItemTypeEnum;
  /**
   *
   * @type {string}
   * @memberof CatalogItem
   */
  number?: string | null;
  /**
   *
   * @type {string}
   * @memberof CatalogItem
   */
  entranceNumber?: string | null;
  /**
   *
   * @type {number}
   * @memberof CatalogItem
   */
  floor?: number | null;
  /**
   *
   * @type {number}
   * @memberof CatalogItem
   */
  areaTotal?: number | null;
  /**
   *
   * @type {number}
   * @memberof CatalogItem
   */
  areaBti?: number | null;
  /**
   *
   * @type {number}
   * @memberof CatalogItem
   */
  areaEstimated?: number | null;
  /**
   *
   * @type {number}
   * @memberof CatalogItem
   */
  areaLiving?: number | null;
  /**
   *
   * @type {number}
   * @memberof CatalogItem
   */
  areaKitchen?: number | null;
  /**
   *
   * @type {number}
   * @memberof CatalogItem
   */
  areaBalcony?: number | null;
  /**
   *
   * @type {number}
   * @memberof CatalogItem
   */
  price?: number | null;
  /**
   *
   * @type {string}
   * @memberof CatalogItem
   */
  owner?: string | null;
  /**
   *
   * @type {number}
   * @memberof CatalogItem
   */
  roomsAmount?: number | null;
  /**
   *
   * @type {number}
   * @memberof CatalogItem
   */
  priceMeter?: number | null;
  /**
   *
   * @type {boolean}
   * @memberof CatalogItem
   */
  studio?: boolean | null;
  /**
   *
   * @type {boolean}
   * @memberof CatalogItem
   */
  freeLayout?: boolean | null;
  /**
   *
   * @type {boolean}
   * @memberof CatalogItem
   */
  euroLayout?: boolean | null;
  /**
   *
   * @type {string}
   * @memberof CatalogItem
   */
  section?: string | null;
  /**
   *
   * @type {number}
   * @memberof CatalogItem
   */
  numberOnFloor?: number | null;
  /**
   *
   * @type {string}
   * @memberof CatalogItem
   */
  image?: string | null;
  /**
   *
   * @type {number}
   * @memberof CatalogItem
   */
  complex?: number | null;
  /**
   *
   * @type {number}
   * @memberof CatalogItem
   */
  house?: number | null;

  lead: CatalogItemLead;
  statusBazis?: StatusBazis;
}

export function CatalogItemFromJSON(json: any): CatalogItem {
  return CatalogItemFromJSONTyped(json, false);
}

export function CatalogItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): CatalogItem {
  if (json === undefined || json === null) {
    return json;
  }

  return {
    id: !exists(json, 'id') ? undefined : json['id'],
    buildingState: json['buildingState'],
    docs: json['docs'],
    isHandOver: json['isHandOver'],
    complexTitle: json['complexTitle'],
    houseNumber: !exists(json, 'houseNumber') ? undefined : json['houseNumber'],
    dateSaleEnd: !exists(json, 'dateSaleEnd') ? undefined : json['dateSaleEnd'],
    dateComplete: json['dateComplete'],
    planImages: !exists(json, 'planImages') ? undefined : json['planImages'],
    address: json['address'],
    maxFloor: json['maxFloor'],
    status: json['status'],
    statusBazis: json['status_bazis'],
    createdAt: !exists(json, 'createdAt') ? undefined : new Date(json['createdAt']),
    updatedAt: !exists(json, 'updatedAt') ? undefined : new Date(json['updatedAt']),
    type: !exists(json, 'type') ? undefined : json['type'],
    number: !exists(json, 'number') ? undefined : json['number'],
    entranceNumber: !exists(json, 'entranceNumber') ? undefined : json['entranceNumber'],
    floor: !exists(json, 'floor') ? undefined : json['floor'],
    areaTotal: !exists(json, 'areaTotal') ? undefined : json['areaTotal'],
    areaBti: !exists(json, 'areaBti') ? undefined : json['areaBti'],
    areaEstimated: !exists(json, 'areaEstimated') ? undefined : json['areaEstimated'],
    areaLiving: !exists(json, 'areaLiving') ? undefined : json['areaLiving'],
    areaKitchen: !exists(json, 'areaKitchen') ? undefined : json['areaKitchen'],
    areaBalcony: !exists(json, 'areaBalcony') ? undefined : json['areaBalcony'],
    price: !exists(json, 'price') ? undefined : json['price'],
    owner: !exists(json, 'owner') ? undefined : json['owner'],
    roomsAmount: !exists(json, 'roomsAmount') ? undefined : json['roomsAmount'],
    priceMeter: !exists(json, 'priceMeter') ? undefined : json['priceMeter'],
    studio: !exists(json, 'studio') ? undefined : json['studio'],
    freeLayout: !exists(json, 'freeLayout') ? undefined : json['freeLayout'],
    euroLayout: !exists(json, 'euroLayout') ? undefined : json['euroLayout'],
    section: !exists(json, 'section') ? undefined : json['section'],
    numberOnFloor: !exists(json, 'numberOnFloor') ? undefined : json['numberOnFloor'],
    image: !exists(json, 'image') ? undefined : json['image'],
    complex: !exists(json, 'complex') ? undefined : json['complex'],
    house: !exists(json, 'house') ? undefined : json['house'],
    lead: !exists(json, 'lead') ? undefined : json['lead'],
  };
}

export function CatalogItemToJSON(value?: CatalogItem | null): any {
  if (value === undefined) {
    return undefined;
  }
  if (value === null) {
    return null;
  }
  return {
    complexTitle: value.complexTitle,
    dateComplete: value.dateComplete,
    planImages: value.planImages,
    docs: value.docs,
    address: value.address,
    maxFloor: value.maxFloor,
    status: value.status,
    type: value.type,
    number: value.number,
    entranceNumber: value.entranceNumber,
    floor: value.floor,
    areaTotal: value.areaTotal,
    areaBti: value.areaBti,
    areaEstimated: value.areaEstimated,
    areaLiving: value.areaLiving,
    areaKitchen: value.areaKitchen,
    areaBalcony: value.areaBalcony,
    price: value.price,
    owner: value.owner,
    roomsAmount: value.roomsAmount,
    priceMeter: value.priceMeter,
    studio: value.studio,
    freeLayout: value.freeLayout,
    euroLayout: value.euroLayout,
    section: value.section,
    numberOnFloor: value.numberOnFloor,
    image: value.image,
    complex: value.complex,
    house: value.house,
    lead: value.lead,
  };
}

/**
 * @export
 * @enum {string}
 */
export enum CatalogItemTypeEnum {
  Property = 'property',
  Apartment = 'apartment',
  Parking = 'parking',
  Office = 'office',
  Pantry = 'pantry',
  Storage = 'storage',
  Commercial = 'commercial',
  Free = 'free',
}

export interface CatalogItemLead {
  leadId: number;
}

export interface StatusBazis {
  id: number;
  name: string;
}